// Segment Global Tracking Implementation
(function() {
  const DEBUG = false;

  // Wait for DOM content to be loaded
  document.addEventListener('DOMContentLoaded', function() {
    
    // Wait for Segment to be loaded
    function initSegmentTracking() {
      if (window.analytics && window.analytics.user) {
        if (DEBUG){
          console.log('Segment global tracking initialized');
        }
        setupGlobalEventTracking();
      } else {
        // Retry after a short delay if analytics isn't available yet
        setTimeout(initSegmentTracking, 500);
      }
    }

    function setupGlobalEventTracking() {
      if(DEBUG){
        console.log(analytics);
      }
      
      // Publish the Segment anonymousId so it can be used in the Segment Customer event pixel (which runs in a sandbox)
      var aid = analytics.user().anonymousId();
      var uid = analytics.user().id();
      
      if(DEBUG){
        console.log("Loaded and have anon id " + aid + " and uid " + uid);
      }

      try {
        const LAST_UID_KEY = "seg_last_identified_uid";
        const lastUid = localStorage.getItem(LAST_UID_KEY);

        // Decide your traits—keep it minimal (avoid sensitive fields)
        // If you have customer info available on window or Liquid, populate here:
        const traits = {}; // e.g., { email: window.__gl?.email, name: window.__gl?.name }

        if (uid && uid !== lastUid) {
          analytics.identify(uid, traits);         // associates current anonId with this user
          localStorage.setItem(LAST_UID_KEY, uid);
          if (DEBUG) console.log("Segment identify sent for uid:", uid, traits);
        }
      } catch (e) {
        if (DEBUG) console.log("Identify de-dupe error", e);
      }

      // Publish to the pixel sandbox (keeps pixel’s SEG_AID/SEG_UID synced)
      window.Shopify?.analytics?.publish?.("segment_identity", { anonymousId: aid, userId: uid });
      if (DEBUG){
        console.log("Published anon id " + aid + " and uid " + uid);
      }

      // // If analytics hasn't created it yet, force creation by calling track once or just retry
      // if (!aid) { 
      //   if (attempt < 40) return setTimeout(() => pushSegmentAid(attempt + 1), 100);
      // }
      // // Send to the pixel sandbox
      // window.Shopify?.analytics?.publish?.("segment_identity", { anonymousId: aid, userId: uid });
      // if(DEBUG){
      //   console.log("Published anon id " + aid + " and uid " + uid);
      // }

      // Global click handler for all buttons
      document.addEventListener('click', function(event) {
        // Find the clicked element or its closest button parent
        const button = event.target.closest('button, a.button, [type="submit"], .btn');
        
        if (button) {
          // Get button properties for tracking
          const buttonText = button.textContent.trim();
          const buttonType = button.getAttribute('type') || '';
          const buttonName = button.getAttribute('name') || '';
          const buttonClass = button.className;
          const buttonId = button.id || '';
          const buttonHref = button.href || '';
          const isCheckout = buttonName === 'checkout' || buttonId.includes('checkout') || buttonClass.includes('checkout');
          const isAddToCart = buttonName === 'add' || buttonId.includes('AddToCart') || buttonClass.includes('add-to-cart');
          
          // Determine button type/category
          let buttonCategory = 'General Button';
          if (isCheckout) buttonCategory = 'Checkout Button';
          else if (isAddToCart) buttonCategory = 'Add to Cart Button';
          else if (button.closest('form')) buttonCategory = 'Form Button';
          else if (button.tagName === 'A') buttonCategory = 'Link Button';
          
          // Get page context
          const pagePath = window.location.pathname;
          const pageTitle = document.title;
          
          // Track the button click
          analytics.track('Shopify Button Tapped', {
            button_text: buttonText,
            button_type: buttonType,
            button_name: buttonName,
            button_id: buttonId,
            button_class: buttonClass,
            button_category: buttonCategory,
            button_href: buttonHref,
            page_path: pagePath,
            page_title: pageTitle,
            timestamp: new Date().toISOString()
          });
          
          if (DEBUG){
            console.log(`Segment tracked: ${buttonCategory} - "${buttonText}"`);
          }
        }
      });
      
      // Form submission tracking
      document.addEventListener('submit', function(event) {
        const form = event.target;
        
        // Skip if this is a standard Shopify form (we'll track these separately)
        if (form.method === 'post' && (form.action.includes('/cart/add') || form.action.includes('/account/login'))) {
          return;
        }
        
        const formId = form.id || '';
        const formClass = form.className;
        const formAction = form.action || '';
        const formMethod = form.method || '';
        const formElements = Array.from(form.elements).map(el => el.name).filter(Boolean);
        
        // Determine form type
        let formType = 'General Form';
        if (formId.includes('contact') || formAction.includes('contact')) formType = 'Contact Form';
        else if (formId.includes('newsletter') || formClass.includes('newsletter')) formType = 'Newsletter Form';
        else if (formId.includes('search') || formAction.includes('search')) formType = 'Search Form';
        
        // Track the form submission
        analytics.track('Shopify Form Submitted', {
          form_id: formId,
          form_class: formClass,
          form_action: formAction,
          form_method: formMethod,
          form_type: formType,
          form_fields: formElements,
          page_path: window.location.pathname,
          page_title: document.title,
          timestamp: new Date().toISOString()
        });
        
        if (DEBUG){
          console.log(`Segment tracked: Form Submission - ${formType}`);
        }

      });

      // Track page views (in addition to the automatic tracking)
      analytics.page("Shopify Page Viewed", {
        url: window.location.href,
        path: window.location.pathname,
        title: document.title,
        referrer: document.referrer
      });

      if (DEBUG){
        console.log(`Segment tracked: Page Viewed - ${window.location.pathname}`);
      }

      // analytics.subscribe("payment_info_submitted", async (event) => {
      //   if (DEBUG){
      //     console.log("payment attempt event");
      //   }
      // });
    }

    // Initialize tracking
    initSegmentTracking();
  });
})();